import { useEffect, useRef } from "react";
import CustomButton from "./CustomButton";
import { FaRegCircleQuestion } from "react-icons/fa6";

const LogoutModal = ({ text, show, onConfirm, onCancel, minorPermission }) => {
  const modalRef = useRef();

  // Close modal on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onCancel(); // Call cancel when click is outside the modal
      }
    };

    if (show) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [show, onCancel]);

  if (!show) return null;

  return (
    <div className="logout-overlay">
      <div className="logout-modal" ref={modalRef}>
        <div className="modal-content text-center">
          <div className="text-center">
            <FaRegCircleQuestion style={{ fontSize: "40px" }} />
          </div>
          <h2 className="fs-3 mb-4 mt-4 fw-bold">{text}</h2>
          {minorPermission ?
            <CustomButton
              buttonText={"Ok"}
              className="border"
              style={{
                width: "100px",
                height: "48px",
                borderRadius: "12px",
                background: "#006FFD",
                color: "#FFFFFF",
              }}
              onClick={onCancel}
            /> :
            <div className="d-flex justify-content-center">
              <CustomButton
                buttonText={"Yes"}
                className=""
                style={{
                  width: "100px",
                  height: "48px",
                  borderRadius: "12px",
                  border: "2px solid rgb(0, 111, 253)",
                  color: "rgb(0, 111, 253)",
                  background: "white",
                  marginRight: "20px",
                }}
                onClick={onConfirm}
              />
              <CustomButton
                buttonText={"No"}
                className="border"
                style={{
                  width: "100px",
                  height: "48px",
                  borderRadius: "12px",
                  background: "#006FFD",
                  color: "#FFFFFF",
                }}
                onClick={onCancel}
              />
            </div>

          }
        </div>
      </div>
    </div>
  );
};

export default LogoutModal;
